import Component from '../classes/Component';

export default class VideoPlay extends Component {
	constructor({ element }) {
		super({
			element,
			elements: {
				playButton: '[data-play-video=YT]',
				iFrameEl: '#YT-player',
			},
		});

		this.element = element;

		this.iframe = null;
		this.player = null;
		this.loadYTVideo();
	}

	loadYTVideo() {
		this.player = new window.YT.Player(this.elements.iFrameEl, {
			height: '390',
			width: '640',
			videoId: this.element.dataset.youtubeVideo,
			rel: 0,
			controls: 0,
			playerVars: {
				enablejsapi: 1,
				modestbranding: 0,
				showinfo: 0,
			},
			events: {
				onReady: () => {
					this.iframe = this.element.querySelector('iframe');
					this.listenForClick();
				},
				onStateChange: event => {
					if (event.data === window.YT.PlayerState.ENDED) this.stopVideo();
				},
			},
		});
	}

	playVideo() {
		this.player.playVideo();
		this.iframe.style.zIndex = 1;
	}

	stopVideo() {
		this.iframe.style.zIndex = null;
		this.player.stopVideo();
	}

	listenForClick() {
		this.elements.playButton.addEventListener('click', () => {
			this.playVideo();
		});
	}
}
